import { Injectable } from '@angular/core';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';

@Injectable({
  providedIn: 'root',
})
// https://docs.datadoghq.com/real_user_monitoring/
export class DataDogService {
  private defaultPrivacyLevel: DefaultPrivacyLevel =
    DefaultPrivacyLevel.MASK_USER_INPUT;

  private applicationId: string;
  private clientToken: string;
  private environment: string;
  private site: string;
  private service: string;
  private version: string;
  private initialized: boolean = false;
  private sessionReplayEnabled: boolean = false;
  private sessionReplaySampleRate: number = 0;

  constructor(private appConfigSetting: AppConfigSettings) {
    this.applicationId = this.appConfigSetting.getconfig(
      'dataDogApplicationId'
    );
    this.clientToken = this.appConfigSetting.getconfig('dataDogClientToken');
    this.site = this.appConfigSetting.getconfig('dataDogSite');
    this.service = this.appConfigSetting.getconfig('domainName');
    this.environment = this.appConfigSetting.getconfig('environment');
    this.version = this.appConfigSetting.getconfig('releaseTag');
    this.sessionReplayEnabled = this.appConfigSetting.getconfig('dataDogSessionReplayEnabled') === 'true';
    this.sessionReplaySampleRate = +this.appConfigSetting.getconfig('dataDogSessionReplaySampleRate');
  }

  initializeRum(): void {
    try {
      datadogRum.init({
        applicationId: this.applicationId,
        clientToken: this.clientToken,
        site: this.site,
        service: this.service,
        env: this.environment,
        version: this.version,
        sampleRate: 100,
        sessionReplaySampleRate: this.sessionReplaySampleRate, // Default: 20, 0 Disables Session Replays
        trackInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: this.defaultPrivacyLevel,
      });
      this.initialized = true;
    } catch (error: unknown) {
      console.error('Failed to initialize DataDog', error);
    }

    if (this.sessionReplayEnabled) {
      datadogRum.startSessionReplayRecording();
    }
  }

  logError(error: unknown, context?: Record<string, unknown>): void {
    if (!this.initialized) {
      return;
    }

    datadogRum.addError(error, context);
  }
}
